export default "__VITE_ASSET__BggAe3ti__"